<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>
    </div>

    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item title="基本信息" name="1">
        <van-field v-model="inputForm.projectName" label="物业项目名：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.customerName" label="年检单位：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.cycle" label="年检周期：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.cost" label="年检费用（元）：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.inspectionRecordDTO.inspectionDate" label="最新年检日期：" label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"
          readonly />
        <van-field v-model="inputForm.inspectionRecordDTO.nextInspectionDate" label="下次年检日期：" label-width='100px' input-align="left" :border="false" autosize rows="1" type="textarea"
          readonly />
        <van-field v-model="inputForm.inspectionRecordDTO.isSign" label="年检标志张贴：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.inspectionRecordDTO.remindDayNum" label="提前提醒天数：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.content" label="年检内容：" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
<!--        <div style="padding-left: 16px;" v-show="inputForm.inspectionRecordDTO.attachList.length > 0">-->
<!--          <p>附件</p>-->
<!--          <a style="display: block; color: #4caedc" v-for="(file,index) in inputForm.inspectionRecordDTO.attachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--        </div>-->
        <div style="padding-left: 16px;" v-show="inputForm.inspectionRecordDTO.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.inspectionRecordDTO.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title=" 关联设备：" name="2">
        <b-table class="bgc-dark" small head-variant="dark" responsive bordered
                 :items="items" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: '100px' }"
            >
          </template>
        </b-table>
<!--        <table>-->
<!--          <thead>-->
<!--            <tr>-->
<!--              <td style="width: 20%;">管理编码</td>-->
<!--              <td style="width: 20%;">设备编码</td>-->
<!--              <td style="width: 20%;">设备名称</td>-->
<!--              <td style="width: 20%;">设备类型</td>-->
<!--              <td style="width: 20%;">运行状态</td>-->
<!--            </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--            <tr v-for="data in this.inputForm.mobileEquipmentList">-->
<!--              <td v-text="data.managementCode"></td>-->
<!--              <td v-text="data.equipmentCode"></td>-->
<!--              <td v-text="data.name"></td>-->
<!--              <td v-text="data.equipmentType"></td>-->
<!--              <td v-text="data.runningStatus"></td>-->
<!--            </tr>-->
<!--          </tbody>-->
<!--        </table>-->
      </van-collapse-item>
<!--      <van-collapse-item title="附件信息" name="3" v-show="inputForm.inspectionRecordDTO.attachList.length > 0">-->
<!--        <a style="display: block;" v-for="file in inputForm.inspectionRecordDTO.attachList"-->
<!--          :href="file.url">{{file.name}}</a>-->
<!--      </van-collapse-item>-->
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import EquipmentAnnualInspection from '@/api/equipment/EquipmentAnnualInspection.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "../../components/processRecord/processRecord";

export default {
  data() {
    return {
      dateinfo: '',
      activeNames: ['1', '2', '3'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        projectName: '',
        customerName: '',
        cycle: '',
        cost: '',
        content: '',
        inspectionRecordDTO: {
          inspectionDate: '',
          nextInspectionDate: '',
          isSign: '',
          remindDayNum: '',
          attachList: []
        },
        mobileEquipmentList: [],
        createDate: '',
        createByName: {
          id: ''
        },
        isDoTask: false,
        isLastTask: false,
        attachIds: [],
        attachList: [],
        reason: '',


      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      fields: [
        {key: 'managementCode', label: '管理编码'},
        {key: 'name', label: '设备名称'},
        {key: 'equipmentType', label: '设备类型'},
        {key: 'runningStatus', label: '运行状态'},
      ],
      items: [],
    }
  },
  mounted() {
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(id)

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      new EquipmentAnnualInspection().queryEquipmentAnnualInspectionById(id).then(({ data }) => {
        data.inspectionRecordDTO.isSign = data.inspectionRecordDTO.isSign == '1' ? '是' : '否'
        this.inputForm = data
        this.items = data.mobileEquipmentList
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.inspectionRecordDTO.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new EquipmentAnnualInspection().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
		  //更新数据库状态
		  _this.inputForm.inspectionRecordDTO.flowType = 3;
		  new EquipmentAnnualInspection().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style>
.bgc-dark th {
  background-color: gainsboro !important;
  /*color: #FFFFFF!important;*/
  font-weight: bold;
}
</style>
